import { useDispatch, useSelector } from 'react-redux'

import { applyPromoCodeAndShowModal } from 'actions/home'
import { redirect } from 'actions/redirect'
import { trackUTMAndPromoCode } from 'actions/tracking'
import { clickClaimDiscountBar } from 'actions/trackingKeys'
import { getPromoBannerText } from 'selectors/features'

import { PROMO_CODE_DATA } from '../homeConfig'
import { getPromoBannerState } from '../homeUtils'

export const useGetPromoBannerData = () => {
  const promoBannerText = useSelector(getPromoBannerText)
  const { canApplyPromo } = useSelector((state) => getPromoBannerState(state))

  const promoText = promoBannerText || PROMO_CODE_DATA.defaultBannerText

  return {
    promoText,
    canApplyPromo,
  }
}

export const useGetPromoBannerDispatchedActions = () => {
  const dispatch = useDispatch()

  const dispatchApplyPromoCodeAndShowModal = () => dispatch(applyPromoCodeAndShowModal())
  const dispatchRedirect = () => dispatch(redirect('/signup/box-size'))
  const dispatchTrackUTMAndPromoCode = () => dispatch(trackUTMAndPromoCode(clickClaimDiscountBar))

  return {
    dispatchApplyPromoCodeAndShowModal,
    dispatchRedirect,
    dispatchTrackUTMAndPromoCode,
  }
}
